import React, { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL + '/api';

export default function BoardPack({ assessmentId, onBack }) {
  const [data, setData] = useState(null);
  const [scores, setScores] = useState([]);

  useEffect(() => {
    (async () => {
      const a = await fetch(`${API_BASE}/risk-assessment/assessments/${assessmentId}/scores`, { credentials: 'include' }).then(r=>r.json());
      if (a.success) { setData(a.assessment); setScores(a.scores || []); }
    })();
  }, [assessmentId]);

  if (!data) return <div className="p-6">Loading…</div>;

  const top = scores.slice(0, 10);

  return (
    <div className="max-w-6xl mx-auto p-6 print:p-0">
      <div className="flex items-center justify-between mb-4 no-print">
        <button onClick={onBack} className="text-slate-600 hover:text-slate-800">← Back</button>
        <button onClick={()=>window.print()} className="px-3 py-2 bg-slate-800 hover:bg-slate-900 text-white rounded-lg">Print</button>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-8">
        <h1 className="text-3xl font-bold text-slate-900">Board Pack — {data.title}</h1>
        <div className="text-slate-600">Year {data.assessment_year} • Compiled {data.compiled_at ? new Date(data.compiled_at).toLocaleDateString() : ''}</div>

        <h2 className="text-xl font-semibold mt-6 mb-2">Top Risks</h2>
        <ol className="list-decimal ml-5 space-y-1">
          {top.map((s, i) => (
            <li key={s.id}>
              <span className="font-medium">{s.domain_name}</span>
              {s.department_name ? ` — ${s.department_name}` : ''}
              <span className="ml-2 text-slate-600">Residual {parseFloat(s.residual_risk).toFixed(1)} (Tier {s.risk_tier})</span>
            </li>
          ))}
        </ol>

        <h2 className="text-xl font-semibold mt-6 mb-2">Summary</h2>
        <div className="grid grid-cols-3 gap-4 text-sm">
          <div className="p-3 border rounded">Tier A: {scores.filter(s=>s.risk_tier==='A').length}</div>
          <div className="p-3 border rounded">Tier B: {scores.filter(s=>s.risk_tier==='B').length}</div>
          <div className="p-3 border rounded">Tier C: {scores.filter(s=>s.risk_tier==='C').length}</div>
        </div>

        <p className="text-sm text-slate-600 mt-6">Notes: Appetite breaches will be tracked via Exceptions. See detail pages for evidence and control ratings.</p>
      </div>
    </div>
  );
}


